var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavHeartOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19739 5.2906C5.87462 3.62613 8.25422 2.74884 10.58 3.0954C12.6757 3.40768 14.6655 4.70349 16.0283 7.18422C17.3912 4.70349 19.3809 3.40768 21.4766 3.0954C23.8024 2.74884 26.182 3.62613 27.8592 5.2906C29.6263 7.04422 30.1585 9.47866 30.0026 11.7652C29.8468 14.0478 29.0018 16.2677 27.9008 17.6735C25.8235 20.3262 25.0832 21.1089 23.2036 22.9275C22.2598 23.8407 21.036 24.907 20.0532 25.741C19.5608 26.1589 19.1269 26.5201 18.816 26.777C18.6605 26.9055 18.5358 27.0079 18.4498 27.0782L18.3508 27.1591L18.3349 27.172C17.6953 27.797 16.861 28.1096 16.0283 28.1096C15.1956 28.1096 14.3613 27.797 13.7217 27.172L13.7058 27.1591L13.6069 27.0782C13.5209 27.0079 13.3961 26.9055 13.2406 26.777C12.9298 26.5201 12.4958 26.1589 12.0034 25.741C11.0207 24.907 9.7968 23.8407 8.85306 22.9275C6.97344 21.1089 6.23313 20.3262 4.15583 17.6735C3.05488 16.2677 2.2098 14.0478 2.05409 11.7652C1.89811 9.47866 2.43033 7.04422 4.19739 5.2906Z",
    fill: "#F46940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3022 6.21875C25.3523 6.38782 27.3463 9.84216 26.5038 13.3248",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHeartOn);
export default __webpack_public_path__ + "static/media/navHeartOn.4ce20d21d5f16de879a6da8781e64576.svg";
export { ForwardRef as ReactComponent };